import { connect } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getPostsDeviationsStreamId } from '../../../../../streams/posts';
import { PostsType } from '../../../../../../types/posts';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getProfileOwnerUser } from '../../../../../selectors/users';

export default connect(state => {
  const streamId = getPostsDeviationsStreamId({ type: PostsType.STATUSES });
  const statuses = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, streamId)
  );
  return {
    streamId,
    ownerUsername: getProfileOwnerUser(state).username,
    statuses,
    total: streamSelectors.getTotal(state, streamId),
  };
});
